import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const Cancel = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // Set body background to black
    document.body.style.backgroundColor = '#000000';
    document.documentElement.style.backgroundColor = '#000000';
    
    // Cleanup: restore default background when component unmounts
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, []);

  return (
    <div className="cancel-page">
      <div className="cancel-icon-container">
        <div className="cancel-icon">
          <FontAwesomeIcon icon={faTimesCircle} className="x-mark" />
        </div>
      </div>

      <h1 className="cancel-heading">
        Payment Canceled
      </h1>

      <p className="cancel-message">
        Your payment didn't go through. Please check the card info and billing address or select a different payment option.
      </p>

      <Link to='/' className="home-button">
        Go back to Home
      </Link>
    </div>
  );
};

export default Cancel;
